import { Injectable } from '@angular/core';
// import { Http,Headers, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LoginService {

  constructor(public httpClient: HttpClient) { }
  private _contactUrl = 'https://hbo.kyriopyrina.com/api/auth-centaur.php/auth/authorize';
    
    // sendLogin(value:any){
        
    //   const body = new URLSearchParams(value);
    //   body.set('username', value.data[0].username);
    //   body.set('password', value.data[0].password);

    //   let headers = new Headers();
    //   headers.append('Content-Type','application/x-www-form-urlencoded');
    //   return this._http.post(this._contactUrl, body, {
    //      headers : headers
    //   }).map( res => res.json() );

    // }

     sendLogin(value:any){
      
      let body = new HttpParams(value);
      body = body.append('username', value.data[0].username);
      body = body.append('password', value.data[0].password);
      let headers = new HttpHeaders();
      headers.append('Content-Type','application/x-www-form-urlencoded');
      return this.httpClient.post(this._contactUrl, body, {
         headers : headers
      }).pipe(map( res => res ));

    }

  }